export const PAGE_SIZE_OPTIONS = [
    {
        value: 25,
        label: '25',
    },
    {
        value: 50,
        label: '50',
    },
    {
        value: 100,
        label: '100',
    },
];

export const SELECT_TYPES = [
    {
        label: 'All rules on this page',
        value: 0,
    }, {
        label: 'All rules',
        value: 1,
    },
];

export const ACTIONS = [
    {
        label: 'enable',
        value: 0,
    }, {
        label: 'disable',
        value: 1,
    },
    {
        label: ' delete',
        value: 2,
    },
    // {
    //     label: 'change label',
    //     value: 3,
    // },
    // {
    //     label: 'change mailbox',
    //     value: 4,
    // },
    // {
    //     label: 'copy to mailbox',
    //     value: 5,
    // },
];

export default {
    PAGE_SIZE_OPTIONS, SELECT_TYPES, ACTIONS,
};
